import React from 'react';
import { useState } from 'react';
import './../../Styles/Header/Profile.scss';
import ProfilePopUp from './ProfilePopUp';
import { profile, pagesRoutes } from '../../Constant';
import profileIcon from './Icon/personal.svg';
import profileIconActive from './Icon/personal_active.svg';
import { BrowserRouter as Router, Routes, Route, Link} from 'react-router-dom';
import { useRef, useEffect } from 'react';

function Profile() {

   const [isActivePopUp, setActivePopUp] = useState(false);

   useEffect(() => {
      window.addEventListener('click', (e) => {
         if (e.target.id !== "imageActiveProfile" && isActivePopUp) {
            setActivePopUp(false)
         }
      })
   })

   const popUp = useRef()

   const popUpActivated = (e) => {
      isActivePopUp ? setActivePopUp(false) : setActivePopUp(true)
   }

   return (
      <div
         id='profilePopUp'
         className='profile__body'
         onClick={e=>popUpActivated(e)}
      >
         {
            isActivePopUp ?
            <img id="imageActiveProfile" src={profileIconActive} alt="" />:
            <img id="imageNotActiveProfile" src={profileIcon} alt="" />
         }
         <div
            ref={popUp}
            className={isActivePopUp ? "profile__popUp profile__popUp-active" : "profile__popUp"}
         >
            <ProfilePopUp>
               <div className="profile__item">
                  <Link to={pagesRoutes[7].path}>
                     {profile[0].title}
                  </Link>
               </div>
            </ProfilePopUp>
         </div>
      </div>
   );
}
export default Profile;